/**
 * Smooth scroll to selector
 */
export default {
    bind(el, binding) {
        $(el).on('click', (e) => {
            const $target = $(binding.value.el);
            e.preventDefault();
            if (!$target.length) {
                return;
            }

            $('html, body').stop().animate({
                scrollTop: $target.offset().top + (binding.value.offset || 0),
            }, (binding.value.speed || 1000));
        });
    },
}
